import { render, staticRenderFns } from "./mt-select.vue?vue&type=template&id=72a249e2&"
import script from "./mt-select.vue?vue&type=script&lang=js&"
export * from "./mt-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports